// extracted by mini-css-extract-plugin
export default {"compare":"CompareProductScenarios_compare__R3wBR"};